module.exports = __webpack_public_path__ + "img/login-banner.bf8dd7bb.jpeg";